import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  // mode: 'history',
  mode: 'hash',
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: 'HOME'
          }
        },{
          path: '/solution',
          name: 'solution',
          component: resolve => require(['@/view/Solution'], resolve),
          meta: {
            title: 'SOLUTION'
          },
          children: [
            {
              path: '/solution',
              redirect: '/solution/smart-home'
            },
            {
              path: '/solution/smart-home',
              name: 'solution',
              component: resolve => require(['@/view/Solution_smart-home'], resolve),
              meta: {
                title: 'SOLUTION Smart Home Automation'
              }
            },
            {
              path: '/solution/audio-video',
              name: 'solution',
              component: resolve => require(['@/view/Solution_audio-video'], resolve),
              meta: {
                title: 'SOLUTION Audio-video System'
              }
            },
            {
              path: '/solution/network',
              name: 'solution',
              component: resolve => require(['@/view/Solution_network'], resolve),
              meta: {
                title: 'SOLUTION Network System'
              }
            },
            {
              path: '/solution/security',
              name: 'solution',
              component: resolve => require(['@/view/Solution_security'], resolve),
              meta: {
                title: 'SOLUTION Security System'
              }
            }
          ]
        },{
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: 'SERVICES'
          }
        },{
          path: '/galleries',
          name: 'galleries',
          component: resolve => require(['@/view/ProjectGalleries'], resolve),
          meta: {
            title: 'Galleries'
          }
        }, 
        // {
        //   path: '/companyintroduction',
        //   name: 'companyintroduction',
        //   component: resolve => require(['@/view/CompanyIntroduction'], resolve),
        //   meta: {
        //     title: 'ABOUT US'
        //   }
        // }, 
        {
          path: '/partners',
          name: 'partners',
          component: resolve => require(['@/view/OurPartners'], resolve),
          meta: {
            title: 'Partners'
          }
        },{
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: 'CONTACT US'
          }
        },{
          path: '/contactusthanks',
          name: 'contactusthanks',
          component: resolve => require(['@/view/ContactUsThanks'], resolve),
          meta: {
            title: 'CONTACT US THANKS'
          }
        },{
          path: '/ourprocess',
          name: 'ourprocess',
          component: resolve => require(['@/view/OurProcess'], resolve),
          meta: {
            title: 'OUR PROCESS'
          }
        },
        // {
        //   path: '/servicedetail',
        //   name: 'servicedetail',
        //   component: resolve => require(['@/view/ServiceDetail'],resolve),
        //   meta: {
        //     title: 'SERVICES'
        //   }
        // }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js